export default "__VITE_ASSET__DGrKWWBp__"